<template>
	<div id="becprice-editor"
		 class="app-home ui-styles"
		 :class="theme">

		<template class="view_container">

			<div class="loading_view" v-if="master_loading">
				<div class="view_spinner_container">
					<span style="color: rgb(0, 79, 146); margin: 0 auto;">
					<icon name="spinner" scale="4"
						  color="rgb(0, 79, 146)" spin></icon></span><br>
					<span>{{ $t('Loading')}}...</span>
				</div>
			</div>

			<div class="master_view">
				<side-nav-bar :filesOpen="filesOpen" :fileOpen="fileOpen" :reportOpen="reportOpen"></side-nav-bar>
				<div class="app-container">
					<bar>
					</bar>
					<h1>B.E.C. nº {{ becprice.number }}, {{ becprice.year }} T{{ becprice.quarter }}<span
							v-if="becprice.dirty">*</span></h1>
					<h2><span v-if="currentLocale === 'ca'">{{ becproperty.name_ca }}</span><span
							v-else-if="currentLocale === 'en'">{{ becproperty.name_en }}</span><span
							v-else>{{ becproperty.name_es }}</span></h2>
					<message
							v-if="becprice.dirty"
							:text="page_dirty_text" icon_name="info" icon_color="rgb(0, 135, 248)"
							border_color="rgb(0, 135, 248)" text_color="rgb(0, 135, 248)">
					</message>
					<div class="datedata">
						<p class="small">{{ $t('Created') }}: {{ millis_to_time(becprice.date_created)
							}}</p>
						<p class="small">{{ $t('Last_modified')
							}}: {{ millis_to_time(becprice.date_modified) }}</p>
					</div>

					<vue-tabs>
						<v-tab :title="data_text">
							<div class="tab_content">
								<form class="bt-form">
									<div class="section-container">
										<h3>{{ $t('Data') }} </h3>

										<div class="field-container">
											<div class="field__group">
												<label class="field__group__label">{{ $t('Number') }}</label>
												<input class="field__group__input"
													   type="number"
													   spellcheck="false"
													   v-model="becprice.number"
													   @input="set_becprice_number">
											</div>
											<div class="field__group">
												<label class="field__group__label">{{ $t('Year') }}</label>
												<input class="field__group__input"
													   type="number"
													   spellcheck="false"
													   v-model="becprice.year"
													   @input="set_becprice_year">
											</div>
											<div class="field__group">
												<label class="field__group__label">{{ $t('Quarter') }}</label>
												<input class="field__group__input"
													   type="number"
													   spellcheck="false"
													   v-model="becprice.quarter"
													   @input="set_becprice_quarter">
											</div>
										</div>
									</div>
									<div class="section-container">
										<h3>{{ $t('Prices') }} </h3>

										<div class="field-container">
											<div class="">
												<table class="table-striped" style="width: 100%">
													<tr>
														<th></th>
														<th style="min-width: 120px;">
															{{ $t('Price') }} (€/m²)
														</th>

													</tr>
													<tr>
														<td style="text-align: left">
															<strong>Movimiento tierras</strong></td>
														<td>
															<input class="field__group__input"
																   type="number"
																   spellcheck="false"
																   v-model="becprice.movimiento_tierras"
																   @input="set_becprice_movimiento_tierras">
														</td>
													</tr>
													<tr>
														<td style="text-align: left">
															<strong>Cimentación y muro sótano</strong></td>
														<td>
															<input class="field__group__input"
																   type="number"
																   spellcheck="false"
																   v-model="becprice.cimentacion_y_muro_sotano"
																   @input="set_becprice_cimentacion_y_muro_sotano">
														</td>
													</tr>
													<tr>
														<td style="text-align: left">
															<strong>Estructura</strong></td>
														<td>
															<input class="field__group__input"
																   type="number"
																   spellcheck="false"
																   v-model="becprice.estructura"
																   @input="set_becprice_estructura">
														</td>
													</tr>
													<tr>
														<td style="text-align: left">
															<strong>Saneamiento (horizontal y vertical)</strong></td>
														<td>
															<input class="field__group__input"
																   type="number"
																   spellcheck="false"
																   v-model="becprice.saneamiento"
																   @input="set_becprice_saneamiento">
														</td>
													</tr>
													<tr>
														<td style="text-align: left">
															<strong>Albañilería gruesa</strong></td>
														<td>
															<input class="field__group__input"
																   type="number"
																   spellcheck="false"
																   v-model="becprice.albanileria_gruesa"
																   @input="set_becprice_albanileria_gruesa">
														</td>
													</tr>
													<tr>
														<td style="text-align: left">
															<strong>Albañilería, azoteas e impermeabilización</strong>
														</td>
														<td>
															<input class="field__group__input"
																   type="number"
																   spellcheck="false"
																   v-model="becprice.albanileria_azoteas"
																   @input="set_becprice_albanileria_azoteas">
														</td>
													</tr>
													<tr>
														<td style="text-align: left">
															<strong>Albañilería, acabados de fachada</strong></td>
														<td>
															<input class="field__group__input"
																   type="number"
																   spellcheck="false"
																   v-model="becprice.albanileria_acabados_fachada"
																   @input="set_becprice_albanileria_acabados_fachada">
														</td>
													</tr>
													<tr>
														<td style="text-align: left">
															<strong>Albañilería, solados</strong></td>
														<td>
															<input class="field__group__input"
																   type="number"
																   spellcheck="false"
																   v-model="becprice.albanileria_solados"
																   @input="set_becprice_albanileria_solados">
														</td>
													</tr>
													<tr>
														<td style="text-align: left">
															<strong>Albañilería, acabados interiores</strong></td>
														<td>
															<input class="field__group__input"
																   type="number"
																   spellcheck="false"
																   v-model="becprice.albanileria_acabados_interiores"
																   @input="set_becprice_albanileria_acabados_interiores">
														</td>
													</tr>
													<tr>
														<td style="text-align: left">
															<strong>Albañilería, ayudas a industriales</strong></td>
														<td>
															<input class="field__group__input"
																   type="number"
																   spellcheck="false"
																   v-model="becprice.albanileria_ayudas_industriales"
																   @input="set_becprice_albanileria_ayudas_industriales">
														</td>
													</tr>
													<tr>
														<td style="text-align: left">
															<strong>Yesería cielosrasos</strong></td>
														<td>
															<input class="field__group__input"
																   type="number"
																   spellcheck="false"
																   v-model="becprice.yeseria_cielosrasos"
																   @input="set_becprice_yeseria_cielosrasos">
														</td>
													</tr>
													<tr>
														<td style="text-align: left">
															<strong>Cerrajería</strong></td>
														<td>
															<input class="field__group__input"
																   type="number"
																   spellcheck="false"
																   v-model="becprice.cerrajeria"
																   @input="set_becprice_cerrajeria">
														</td>
													</tr>
													<tr>
														<td style="text-align: left">
															<strong>Carpintería exterior</strong></td>
														<td>
															<input class="field__group__input"
																   type="number"
																   spellcheck="false"
																   v-model="becprice.carpinteria_exterior"
																   @input="set_becprice_carpinteria_exterior">
														</td>
													</tr>
													<tr>
														<td style="text-align: left">
															<strong>Carpintería interior</strong></td>
														<td>
															<input class="field__group__input"
																   type="number"
																   spellcheck="false"
																   v-model="becprice.carpinteria_interior"
																   @input="set_becprice_carpinteria_interior">
														</td>
													</tr>
													<tr>
														<td style="text-align: left">
															<strong>Persianas</strong></td>
														<td>
															<input class="field__group__input"
																   type="number"
																   spellcheck="false"
																   v-model="becprice.persianas"
																   @input="set_becprice_persianas">
														</td>
													</tr>
													<tr>
														<td style="text-align: left">
															<strong>Fontanería</strong></td>
														<td>
															<input class="field__group__input"
																   type="number"
																   spellcheck="false"
																   v-model="becprice.fontaneria"
																   @input="set_becprice_fontaneria">
														</td>
													</tr>
													<tr>
														<td style="text-align: left">
															<strong>Material sanitario grifería</strong></td>
														<td>
															<input class="field__group__input"
																   type="number"
																   spellcheck="false"
																   v-model="becprice.mat_sanitario_griferia"
																   @input="set_becprice_mat_sanitario_griferia">
														</td>
													</tr>
													<tr>
														<td style="text-align: left">
															<strong>Electricidad</strong></td>
														<td>
															<input class="field__group__input"
																   type="number"
																   spellcheck="false"
																   v-model="becprice.electricidad"
																   @input="set_becprice_electricidad">
														</td>
													</tr>
													<tr>
														<td style="text-align: left">
															<strong>Aire acondicionado</strong></td>
														<td>
															<input class="field__group__input"
																   type="number"
																   spellcheck="false"
																   v-model="becprice.aire_acondicionado"
																   @input="set_becprice_aire_acondicionado">
														</td>
													</tr>
													<tr>
														<td style="text-align: left">
															<strong>Instalaciones especiales</strong></td>
														<td>
															<input class="field__group__input"
																   type="number"
																   spellcheck="false"
																   v-model="becprice.instal_especiales"
																   @input="set_becprice_instal_especiales">
														</td>
													</tr>
													<tr>
														<td style="text-align: left">
															<strong>Fumistería y muebles cocina</strong></td>
														<td>
															<input class="field__group__input"
																   type="number"
																   spellcheck="false"
																   v-model="becprice.fumisteria_y_muebles_cocina"
																   @input="set_becprice_fumisteria_y_muebles_cocina">
														</td>
													</tr>
													<tr>
														<td style="text-align: left">
															<strong>Ascensores</strong></td>
														<td>
															<input class="field__group__input"
																   type="number"
																   spellcheck="false"
																   v-model="becprice.ascensores"
																   @input="set_becprice_ascensores">
														</td>
													</tr>
													<tr>
														<td style="text-align: left">
															<strong>Vidrieria</strong></td>
														<td>
															<input class="field__group__input"
																   type="number"
																   spellcheck="false"
																   v-model="becprice.vidrieria"
																   @input="set_becprice_vidrieria">
														</td>
													</tr>
													<tr>
														<td style="text-align: left">
															<strong>Pintura y estucos</strong></td>
														<td>
															<input class="field__group__input"
																   type="number"
																   spellcheck="false"
																   v-model="becprice.pintura_y_estucos"
																   @input="set_becprice_pintura_y_estucos">
														</td>
													</tr>
													<tr>
														<td style="text-align: left">
															<strong>Calefacción</strong></td>
														<td>
															<input class="field__group__input"
																   type="number"
																   spellcheck="false"
																   v-model="becprice.calefaccion"
																   @input="set_becprice_calefaccion">
														</td>
													</tr>
													<tr>
														<td style="text-align: left">
															<strong>Energía solar a.c.s.</strong></td>
														<td>
															<input class="field__group__input"
																   type="number"
																   spellcheck="false"
																   v-model="becprice.energia_solar_acs"
																   @input="set_becprice_energia_solar_acs">
														</td>
													</tr>

													<tr>
														<td style="text-align: left">
															<strong>Jardinería decorativa</strong></td>
														<td>
															<input class="field__group__input"
																   type="number"
																   spellcheck="false"
																   v-model="becprice.jardineria_decorativa"
																   @input="set_becprice_jardineria_decorativa">
														</td>
													</tr>
													<tr>
														<td style="text-align: left">
															<strong>Renovación de aire</strong></td>
														<td>
															<input class="field__group__input"
																   type="number"
																   spellcheck="false"
																   v-model="becprice.renovacion_aire"
																   @input="set_becprice_renovacion_aire">
														</td>
													</tr>

													<tr>
														<td style="text-align: left">
															<strong>Subtotal</strong></td>
														<td>
															<!--<input class="field__group__input"
																   type="number"
																   spellcheck="false"
																   v-model="becprice.subtotal"
																   @input="set_becprice_subtotal">-->
															<strong><span>{{ becprice.subtotal | formatNumber
																}} €/m²</span></strong>
														</td>
													</tr>
													<tr>
														<td style="text-align: left">
															<strong>Seguridad y salud (2%)</strong></td>
														<td>
															<!--<input class="field__group__input"
																   type="number"
																   spellcheck="false"
																   v-model="becprice.seguridad_y_salud"
																   @input="set_becprice_seguridad_y_salud">-->
															<span>{{ becprice.seguridad_y_salud | formatNumber
																}} €/m²</span>
														</td>
													</tr>
													<tr>
														<td style="text-align: left">
															<strong>Total</strong></td>
														<td>
															<!--<input class="field__group__input"
																   type="number"
																   spellcheck="false"
																   v-model="becprice.total"
																   @input="set_becprice_total">-->
															<strong><span>{{ becprice.total | formatNumber
																}} €/m²</span></strong>
														</td>
													</tr>


												</table>
											</div>
										</div>


									</div>

								</form>
							</div>
						</v-tab>
						<v-tab :title="metadata_text">
							<div class="tab_content">
								<form class="bt-form">

								</form>
							</div>
						</v-tab>
					</vue-tabs>

					<div>
						<div @click.prevent="onGoUp" style="width: fit-content; margin-left: auto">
							<icon-button icon="chevron-left" :text="goup_button_text"
										 icon_color="black"
										 text_color="black" border_color="lightgray"></icon-button>
						</div>
					</div>
					<div>
						<div @click.prevent="onSaveCurrentBecProperty({go_up: false})"
							 style="width: fit-content; margin-left: auto">
							<icon-button icon="floppy-o" :text="save_button_text" icon_color="white"
										 text_color="white" border_color="#006bc5"
										 background_color="#0087F8"></icon-button>
						</div>
					</div>
					<div>
						<div @click.prevent="onSaveCurrentBecProperty({go_up: true})"
							 style="width: fit-content; margin-left: auto">
							<icon-button icon="floppy-o" :text="save_and_go_up_button_text" icon_color="white"
										 text_color="white" border_color="#006bc5"
										 background_color="#0087F8"></icon-button>
						</div>
					</div>
					<message
							v-if="becprice.dirty"
							:text="page_dirty_text" icon_name="info" icon_color="rgb(0, 135, 248)"
							border_color="rgb(0, 135, 248)" text_color="rgb(0, 135, 248)">
					</message>
					<!--
					<bar>
					</bar>
-->
				</div>
			</div>

		</template>
	</div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex'
    import Vue from 'vue'
    import _ from 'lodash'
    import moment from 'moment'
    import { dateMixin, localStorageMixin, mathMixin, objectsMixin } from '../../../mixins'
    import Spinner from '../../../components/Spinner.vue'
    import Search from '../../../components/ContactsSearch/Index.vue'
    import Editor from '../../../components/Editor/Index.vue'
    import Bar from '../../../components/Bar/Index.vue'
    import IconButton from '../../../components/IconButton/Index.vue'
    import SideNavBar from '../../../components/SideNavBar/Index.vue'

    import router from '../../../router/index.js'

    import Message from '../../../components/Message.vue'

    import petitioner_typeOptions from '../../../options/petitioner_types'

    import Datatable from '../../../components/Datatable/datatable.vue'
    import DatatableColumn from '../../../components/Datatable/datatable-column.vue'
    import aggregators from '../../../aggregators/aggregators.js'
    import formatters from '../../../formatters/formatters.js'
    import Checkbox from '../../../components/Toggles/checkbox.vue'
    import Paginator from '../../../components/Paginator/paginator.vue'

    export default {
        name: 'becprice-editor',

        mixins: [
            dateMixin,
            localStorageMixin,
			mathMixin,
            objectsMixin
        ],

        data: () => ({
            loading: true,
            master_loading: true,
            filesOpen: true,
            fileOpen: true,
            reportOpen: true,
            error: null,
            success_message: null,
            metadata_text: Vue.i18n.translate('Metadata'),
            data_text: Vue.i18n.translate('Data'),
            report_title_error_text: Vue.i18n.translate('Report_title_missing_error_text'),
            new_real_estate_button_text: Vue.i18n.translate('Add_real_estate'),
            new_becprice_button_text: Vue.i18n.translate('Add_bec_number'),
            cancel_button_text: Vue.i18n.translate('Cancel'),
            goup_button_text: Vue.i18n.translate('Go_up') + ' ' + Vue.i18n.translate('without_saving'),
            pdf_button_text: Vue.i18n.translate('Print_report_in_PDF'),
            save_button_text: Vue.i18n.translate('Save'),
            save_and_go_up_button_text: Vue.i18n.translate('Save') + ' ' + Vue.i18n.translate('and') + ' ' + Vue.i18n.translate('go_up'),
            page_dirty_text: Vue.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: Vue.i18n.translate('Actions'),
            filter_placeholder: Vue.i18n.translate('Type_here_to_filter_paginated_data'),
            becprice_appraisaldateValue: null,
            duplicate_text: Vue.i18n.translate('Duplicate'),
            edit_text: Vue.i18n.translate('Edit'),
            delete_text: Vue.i18n.translate('Delete'),
            discard_text: Vue.i18n.translate('Discard'),
            openlink_text: Vue.i18n.translate('Open_link_in_new_tab'),
            petitionerValue: null,
            petitioner_typeValue: null,
            petitioner_typeOptions,
        }),

        created () {
            this.master_loading = false
        },

        components: {
            Bar,
            Message,
            IconButton,
            Spinner,
            SideNavBar,
            Checkbox,
            Datatable,
            DatatableColumn,
            Paginator
        },

        computed: {
            ...mapGetters([
                'theme',
                'tags_display',
                'currentLocale',
                'becproperty',
                'becprice'
            ])
        },

        methods: {
            ...mapActions(
                [
                    'CHECK_BECPRICE_BECPRICE_APPRAISALS',
                    'CREATE_NEW_BECPRICE',
                    'DELETE_BECPRICE',
                    'FETCH_BECPRICE_BECPRICES',
                    'RESET_BECPRICE',
                    'SET_BECPRICE',
                    'UPDATE_BECPRICE',

                    'SET_BECPRICE_NUMBER',
                    'SET_BECPRICE_QUARTER',
                    'SET_BECPRICE_YEAR',
                    'SET_BECPRICE_AIRE_ACONDICIONADO',
                    'SET_BECPRICE_ALBANILERIA_ACABADOS_FACHADA',
                    'SET_BECPRICE_ALBANILERIA_ACABADOS_INTERIORES',
                    'SET_BECPRICE_ALBANILERIA_AYUDAS_INDUSTRIALES',
                    'SET_BECPRICE_ALBANILERIA_AZOTEAS',
                    'SET_BECPRICE_ALBANILERIA_GRUESA',
                    'SET_BECPRICE_ALBANILERIA_SOLADOS',
                    'SET_BECPRICE_ASCENSORES',
                    'SET_BECPRICE_CALEFACCION',
                    'SET_BECPRICE_CARPINTERIA_EXTERIOR',
                    'SET_BECPRICE_CARPINTERIA_INTERIOR',
                    'SET_BECPRICE_CERRAJERIA',
                    'SET_BECPRICE_CIMENTACION_Y_MURO_SOTANO',
                    'SET_BECPRICE_ELECTRICIDAD',
                    'SET_BECPRICE_ENERGIA_SOLAR_ACS',
                    'SET_BECPRICE_ESTRUCTURA',
                    'SET_BECPRICE_FONTANERIA',
                    'SET_BECPRICE_FUMISTERIA_Y_MUEBLES_COCINA',
                    'SET_BECPRICE_INSTAL_ESPECIALES',
                    'SET_BECPRICE_JARDINERIA_DECORATIVA',
                    'SET_BECPRICE_MAT_SANITARIO_GRIFERIA',
                    'SET_BECPRICE_MOVIMIENTO_TIERRAS',
                    'SET_BECPRICE_PERSIANAS',
                    'SET_BECPRICE_PINTURA_Y_ESTUCOS',
                    'SET_BECPRICE_RENOVACION_AIRE',
                    'SET_BECPRICE_SANEAMIENTO',
                    'SET_BECPRICE_SEGURIDAD_Y_SALUD',
                    'SET_BECPRICE_SUBTOTAL',
                    'SET_BECPRICE_TOTAL',
                    'SET_BECPRICE_VIDRIERIA',
                    'SET_BECPRICE_YESERIA_CIELOSRASOS',

                ]),

            set_becprice_number: _.debounce(function (e) {
                this.SET_BECPRICE_NUMBER(Number(e.target.value))
            }, 1000),
            set_becprice_quarter: _.debounce(function (e) {
                this.SET_BECPRICE_QUARTER(Number(e.target.value))
            }, 1000),
            set_becprice_year: _.debounce(function (e) {
                this.SET_BECPRICE_YEAR(Number(e.target.value))
            }, 1000),
            set_becprice_aire_acondicionado: _.debounce(function (e) {
                this.SET_BECPRICE_AIRE_ACONDICIONADO(Number(e.target.value))
                this.calc_construction_price_totals()
            }, 1000),
            set_becprice_albanileria_acabados_fachada: _.debounce(function (e) {
                this.SET_BECPRICE_ALBANILERIA_ACABADOS_FACHADA(Number(e.target.value))
                this.calc_construction_price_totals()
            }, 1000),
            set_becprice_albanileria_acabados_interiores: _.debounce(function (e) {
                this.SET_BECPRICE_ALBANILERIA_ACABADOS_INTERIORES(Number(e.target.value))
                this.calc_construction_price_totals()
            }, 1000),
            set_becprice_albanileria_ayudas_industriales: _.debounce(function (e) {
                this.SET_BECPRICE_ALBANILERIA_AYUDAS_INDUSTRIALES(Number(e.target.value))
                this.calc_construction_price_totals()
            }, 1000),
            set_becprice_albanileria_azoteas: _.debounce(function (e) {
                this.SET_BECPRICE_ALBANILERIA_AZOTEAS(Number(e.target.value))
                this.calc_construction_price_totals()
            }, 1000),
            set_becprice_albanileria_gruesa: _.debounce(function (e) {
                this.SET_BECPRICE_ALBANILERIA_GRUESA(Number(e.target.value))
                this.calc_construction_price_totals()
            }, 1000),
            set_becprice_albanileria_solados: _.debounce(function (e) {
                this.SET_BECPRICE_ALBANILERIA_SOLADOS(Number(e.target.value))
                this.calc_construction_price_totals()
            }, 1000),
            set_becprice_ascensores: _.debounce(function (e) {
                this.SET_BECPRICE_ASCENSORES(Number(e.target.value))
                this.calc_construction_price_totals()
            }, 1000),
            set_becprice_calefaccion: _.debounce(function (e) {
                this.SET_BECPRICE_CALEFACCION(Number(e.target.value))
                this.calc_construction_price_totals()
            }, 1000),
            set_becprice_carpinteria_exterior: _.debounce(function (e) {
                this.SET_BECPRICE_CARPINTERIA_EXTERIOR(Number(e.target.value))
                this.calc_construction_price_totals()
            }, 1000),
            set_becprice_carpinteria_interior: _.debounce(function (e) {
                this.SET_BECPRICE_CARPINTERIA_INTERIOR(Number(e.target.value))
                this.calc_construction_price_totals()
            }, 1000),
            set_becprice_cerrajeria: _.debounce(function (e) {
                this.SET_BECPRICE_CERRAJERIA(Number(e.target.value))
                this.calc_construction_price_totals()
            }, 1000),
            set_becprice_cimentacion_y_muro_sotano: _.debounce(function (e) {
                this.SET_BECPRICE_CIMENTACION_Y_MURO_SOTANO(Number(e.target.value))
                this.calc_construction_price_totals()
            }, 1000),
            set_becprice_electricidad: _.debounce(function (e) {
                this.SET_BECPRICE_ELECTRICIDAD(Number(e.target.value))
                this.calc_construction_price_totals()
            }, 1000),
            set_becprice_energia_solar_acs: _.debounce(function (e) {
                this.SET_BECPRICE_ENERGIA_SOLAR_ACS(Number(e.target.value))
                this.calc_construction_price_totals()
            }, 1000),
            set_becprice_estructura: _.debounce(function (e) {
                this.SET_BECPRICE_ESTRUCTURA(Number(e.target.value))
                this.calc_construction_price_totals()
            }, 1000),
            set_becprice_fontaneria: _.debounce(function (e) {
                this.SET_BECPRICE_FONTANERIA(Number(e.target.value))
                this.calc_construction_price_totals()
            }, 1000),
            set_becprice_fumisteria_y_muebles_cocina: _.debounce(function (e) {
                this.SET_BECPRICE_FUMISTERIA_Y_MUEBLES_COCINA(Number(e.target.value))
                this.calc_construction_price_totals()
            }, 1000),
            set_becprice_instal_especiales: _.debounce(function (e) {
                this.SET_BECPRICE_INSTAL_ESPECIALES(Number(e.target.value))
                this.calc_construction_price_totals()
            }, 1000),
            set_becprice_jardineria_decorativa: _.debounce(function (e) {
                this.SET_BECPRICE_JARDINERIA_DECORATIVA(Number(e.target.value))
                this.calc_construction_price_totals()
            }, 1000),
            set_becprice_mat_sanitario_griferia: _.debounce(function (e) {
                this.SET_BECPRICE_MAT_SANITARIO_GRIFERIA(Number(e.target.value))
                this.calc_construction_price_totals()
            }, 1000),
            set_becprice_movimiento_tierras: _.debounce(function (e) {
                this.SET_BECPRICE_MOVIMIENTO_TIERRAS(Number(e.target.value))
                this.calc_construction_price_totals()
            }, 1000),
            set_becprice_persianas: _.debounce(function (e) {
                this.SET_BECPRICE_PERSIANAS(Number(e.target.value))
                this.calc_construction_price_totals()
            }, 1000),
            set_becprice_pintura_y_estucos: _.debounce(function (e) {
                this.SET_BECPRICE_PINTURA_Y_ESTUCOS(Number(e.target.value))
                this.calc_construction_price_totals()
            }, 1000),
            set_becprice_renovacion_aire: _.debounce(function (e) {
                this.SET_BECPRICE_RENOVACION_AIRE(Number(e.target.value))
                this.calc_construction_price_totals()
            }, 1000),
            set_becprice_saneamiento: _.debounce(function (e) {
                this.SET_BECPRICE_SANEAMIENTO(Number(e.target.value))
                this.calc_construction_price_totals()
            }, 1000),
            set_becprice_seguridad_y_salud: _.debounce(function (e) {
                this.SET_BECPRICE_SEGURIDAD_Y_SALUD(Number(e.target.value))
            }, 1000),
            set_becprice_subtotal: _.debounce(function (e) {
                this.SET_BECPRICE_SUBTOTAL(Number(e.target.value))
            }, 1000),
            set_becprice_total: _.debounce(function (e) {
                this.SET_BECPRICE_TOTAL(Number(e.target.value))
            }, 1000),
            set_becprice_vidrieria: _.debounce(function (e) {
                this.SET_BECPRICE_VIDRIERIA(Number(e.target.value))
                this.calc_construction_price_totals()
            }, 1000),
            set_becprice_yeseria_cielosrasos: _.debounce(function (e) {
                this.SET_BECPRICE_YESERIA_CIELOSRASOS(Number(e.target.value))
				this.calc_construction_price_totals()
            }, 1000),
            calc_construction_price_totals: function () {

                let subtotal =
                    this.becprice.aire_acondicionado +
                    this.becprice.albanileria_acabados_fachada +
                    this.becprice.albanileria_acabados_interiores +
                    this.becprice.albanileria_ayudas_industriales +
                    this.becprice.albanileria_azoteas +
                    this.becprice.albanileria_gruesa +
                    this.becprice.albanileria_solados +
                    this.becprice.ascensores +
                    this.becprice.calefaccion +
                    this.becprice.carpinteria_exterior +
                    this.becprice.carpinteria_interior +
                    this.becprice.cerrajeria +
                    this.becprice.cimentacion_y_muro_sotano +
                    this.becprice.electricidad +
                    this.becprice.energia_solar_acs +
                    this.becprice.estructura +
                    this.becprice.fontaneria +
                    this.becprice.fumisteria_y_muebles_cocina +
                    this.becprice.instal_especiales +
                    this.becprice.jardineria_decorativa +
                    this.becprice.mat_sanitario_griferia +
                    this.becprice.movimiento_tierras +
                    this.becprice.persianas +
                    this.becprice.pintura_y_estucos +
                    this.becprice.renovacion_aire +
                    this.becprice.saneamiento +
                    this.becprice.vidrieria +
                    this.becprice.yeseria_cielosrasos

				let ss = this.roundToTwo(subtotal * 0.02)
				let total = subtotal + ss

                this.SET_BECPRICE_SUBTOTAL(subtotal)
                this.SET_BECPRICE_SEGURIDAD_Y_SALUD(ss)
                this.SET_BECPRICE_TOTAL(total)

            },
            onSaveCurrentBecProperty: function (data) {
                this.UPDATE_BECPRICE({
                    object: this.becprice,
                    path: this.becprice.path,
                    key: this.becprice.id
                }).then((res) => {
                    // router.go(-1)
                    if (data.go_up) {
                        this.onGoUp()
                    }
                })
            },
            onGoBack: function () {
                router.go(-1)
            },
            onGoUp: function () {
                this.$router.push({name: 'becproperties-index'})
            }
        },
        head: {
            title: {
                inner: 'Edit becprice'
            }
        }

    }
</script>


// WEBPACK FOOTER //
// BecPriceEditor.vue?d075ee10